<template>
	<div>
		<ty-row :gutter="20">
			<ty-col :sm="24" :md="14" :lg="11" :xl="9" class="mt-2">
				<create-transaction :instance="instance_id" type="both" />
			</ty-col>
			<ty-col :sm="24" :md="10" :lg="13" :xl="15" class="mt-2">
				<horse-race/>
			</ty-col>
		</ty-row>
		<Table class="mt-4" :instance="instance_id" ref="list" />
	</div>
</template>

<script>
	import Table from '../components/BoughtAndSoldTable'
	import CreateBoughtSoldTransactionForm from '../components/CreateBoughtSoldInvoiceForm'
	// import NewSellBuy from '@/components/transaction/NewSellBuy.vue'
	import HorseRace from '../components/HorseRace.vue'
	export default {
		components: {
			Table,
			// 'create-transaction': NewSellBuy,
			'create-transaction': CreateBoughtSoldTransactionForm,
			'horse-race': HorseRace,
		},
		inject: ['getInstance'],
		data() {
			const {
				getInstance
			} = this;
			return {
				instance_id: getInstance().id,

			}
		},
		methods: {
			newTransaction() {
				this.$refs.list.getTransactions('');
			}
		}
	}
</script>